module.exports = __webpack_public_path__ + "img/biei_oshiho2.055a6b09.png";